import React, { ElementType } from "react";
import Link, { ILinkProps } from "./Link";

export interface IIconLinkProps<LinkType> extends ILinkProps<LinkType> {
  /**
   * Existing SVG Icon component
   *
   *@type {ReactElement}
   */
  icon?: ElementType;
}

function IconLink<LinkType>({
  icon: IconComponent,
  classes,
  children,
  ...other
}: IIconLinkProps<LinkType>): JSX.Element {
  return (
    <Link classes={classes} {...other}>
      <>
        {IconComponent && <IconComponent />}
        {children}
      </>
    </Link>
  );
}

export default IconLink;
